import { memo } from "react";
import { useLocalization } from "@fluent/react";

import cc from "classcat";
import SectionCard from "../SectionCard";
import styles from "./ArrayPlusWidget.module.scss";

type ArrayPlusWidgetProps = {
    fullScreen?: boolean;
};

function ArrayPlusWidget({ fullScreen = false }: ArrayPlusWidgetProps) {
    const { l10n } = useLocalization();
    return (
        <div className={cc([styles.container, fullScreen && styles.fullScreen])}>
            <SectionCard classNames="dashboard-section-card">
                <SectionCard.Title text={l10n.getString("heading-array-plus")} />
                <iframe src="/credit_report/array" className={styles.iframe} title="Array+ Credit Report" />
            </SectionCard>
        </div>
    );
}

export default memo(ArrayPlusWidget);